import React, { useEffect, useState } from "react";
import Dashboardmenus from "./Dashboardmenus";
import coupontag from "../../../images/coupon-tag.svg";
import redgemshards from "../../../images/red-gem-shards.png";
import bluegemshards from "../../../images/blue-gem-shards.png";
import greengemshards from "../../../images/green-gem-shards.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { authcallApi } from "../../common/API/Api";
import { showProcessToast, updateToastMessage } from "../../common/Tostify";
import { useNotification } from "../../common/Notification";
import { useTranslation } from "react-i18next";
import { result } from "lodash";
import { getBaseUrl } from "../../common/BaseUrl";
const Marketdashboard = () => {
  const { t } = useTranslation();
  const { showNotification } = useNotification();
  let base_url = getBaseUrl();
  const location = useLocation();
    const navigate = useNavigate();
  const state = location.state;
  const [couponlist, setCoponlist] = useState([]);
  const [rewardslist, setRewardslist] = useState([]);
  const [rewardspilanlist, setRewardspilanlist] = useState([]);
  const [rewardhistorylist, setRewardhistorylist] = useState([]);
  const [paymentgiftlist, setPaymentlist] = useState([]);
  const getpromocodes = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(postdata, `api/activecoupon`, "GET");
      if (res?.data?.success) {
        setCoponlist(res?.data?.data);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const getmarketrewards = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(postdata, `api/rewards`, "GET");
      if (res?.data?.success && Array.isArray(res?.data?.data)) {
        let data = [...res.data.data];

        if (data.length > 0) data[0].image = redgemshards;
        if (data.length > 1) data[1].image = bluegemshards;
        if (data.length > 2) data[2].image = greengemshards;

        setRewardslist(data);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const getrewardspilan = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(postdata, `api/rewardsrule`, "GET");
      if (res?.data?.success) {
        const gemImages = {
          1: redgemshards,
          2: bluegemshards,
          3: greengemshards,
        };

        // Transform data
        const updatedData = res?.data?.data.map((item) => ({
          ...item,
          shards_required: Object.fromEntries(
            Object.entries(item.shards_required).map(([key, value]) => [
              key,
              { image: gemImages[key], value },
            ])
          ),
        }));
        setRewardspilanlist(updatedData);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const purchase = async (id) => {
    try {
      // const processToastId = showProcessToast("Loading data... Please wait.");
      let postdata = {
        reward_id: id,
      };
      const formData = new FormData();
      for (let key in postdata) {
        if (postdata.hasOwnProperty(key)) {
          formData.append(key, postdata[key]);
        }
      }
      let res = await authcallApi(formData, `api/rewardsvalidate`, `POST`);
      if (res?.data?.success) {
        getmarketrewards();
        // updateToastMessage(processToastId, res?.data?.message, "success");
        showNotification(res?.data?.message, "success");
      } else {
        // updateToastMessage(processToastId, res?.data?.message, "error");
        showNotification(res?.data?.message, "error");
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const getrewoardhistory = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(postdata, `api/rewardshistory`, "GET");
      if (res?.data?.success) {
        setRewardhistorylist(res?.data?.purchases);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    getpromocodes();
    getmarketrewards();
    getrewardspilan();
    getrewoardhistory();
  }, []);
  let shardsstyle = {
    display: "-webkit-box",
    WebkitLineClamp: 3, // Limits text to 2 lines
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "normal",
    maxWidth: "100%", // Adjust if needed
  };
  const getgifts = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(postdata, `api/gifts`, "GET");
      if (res?.data?.success) {
        setPaymentlist(res?.data?.data);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    getgifts();
  }, []);
    useEffect(() => {
          if (!location.state) {
            navigate(location.pathname, {
              replace: true,
               state:{ from: "market" }
            });
          }
        }, [location, navigate]);
  return (
    <React.Fragment>
      <Dashboardmenus />
      <div className="dashboard-contentbody">
        <section className="Equlix-Rewards-Page">
          <div className="container-fluid">
            <div
              className="Equlix-Rewards-Center cardBox mb-4"
              style={{
                minHeight: "300px",
              }}
            >
              <div className="row justify-content-between">
                <div className="col-lg-7 col-md-6 col-sm-12">
                  <div className="row">
                    <div className="col-12">
                      <h2 className="card_title">
                        {t("Equlix Rewards Center")}
                      </h2>
                      <p style={{ width: "95%" }}>
                        {t(
                          "Earn exciting rewards as you trade. Explore exclusive offers, bonuses, and loyalty perks all in one place!"
                        )}
                      </p>
                      <div className="rewards-bx">
                        <div className="your-rewards">
                          {/* <p>{t("Your rewards")}</p>
                          <h2>0.00 USD</h2> */}
                        </div>
                        <div className="withdrawal-btn">
                          {/* <Link to="" onClick={(e)=>e.preventDefault()} className="btn darkBtnn">
                            {t("Redeem Rewards")}
                          </Link> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-5 col-md-6 col-sm-12"></div>
              </div>
            </div>
            <div className="row DepositSec">
              <div className="col-xl-12">
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <Link
                      // className="nav-link active"
                      className={`nav-link ${
                        state?.from === "market" && "active"
                      }`}
                      to={`${base_url}marketdashboard`}
                      state={{ from: "market" }}
                      id="marketBonus-tab"

                      // data-bs-toggle="tab"
                      // data-bs-target="#marketBonus"
                      // type="button"
                      // role="tab"
                      // aria-controls="marketBonus"
                      // aria-selected="true"
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18.3333 7.08329C18.3333 10.075 15.9083 12.5 12.9167 12.5C12.775 12.5 12.625 12.4916 12.4833 12.4833C12.275 9.84163 10.1583 7.72495 7.51666 7.51662C7.50832 7.37495 7.5 7.22496 7.5 7.08329C7.5 4.09163 9.925 1.66663 12.9167 1.66663C15.9083 1.66663 18.3333 4.09163 18.3333 7.08329Z"
                          stroke="#0094FF"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M12.5003 12.9167C12.5003 15.9083 10.0753 18.3333 7.08366 18.3333C4.09199 18.3333 1.66699 15.9083 1.66699 12.9167C1.66699 9.925 4.09199 7.5 7.08366 7.5C7.22533 7.5 7.37532 7.50832 7.51698 7.51666C10.1586 7.72499 12.2753 9.84168 12.4837 12.4833C12.492 12.625 12.5003 12.775 12.5003 12.9167Z"
                          stroke="#0094FF"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M4.65866 1.66663H2.50033C2.04199 1.66663 1.66699 2.04163 1.66699 2.49996V4.65829C1.66699 5.39996 2.56699 5.77495 3.09199 5.24995L5.25032 3.09162C5.76698 2.56662 5.40032 1.66663 4.65866 1.66663Z"
                          stroke="#0094FF"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M15.3418 18.3333H17.5001C17.9584 18.3333 18.3334 17.9583 18.3334 17.5V15.3417C18.3334 14.6 17.4334 14.225 16.9084 14.75L14.7501 16.9083C14.2334 17.4333 14.6001 18.3333 15.3418 18.3333Z"
                          stroke="#0094FF"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      {t("Market")}
                    </Link>
                  </li>
                  <li className="nav-item" role="presentation">
                    <Link
                      className={`nav-link ${
                        state?.from === "social_rewards" && "active"
                      }`}
                      to={`${base_url}marketdashboard`}
                      state={{ from: "social_rewards" }}
                      id="SocialRewards-tab"
                      // data-bs-toggle="tab"
                      // data-bs-target="#SocialRewards"
                      // type="button"
                      // role="tab"
                      // aria-controls="SocialRewards"
                      // aria-selected="false"
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_2499_3466)">
                          <path
                            d="M7.50033 7.49996H7.50866M12.5003 12.5H12.5087M13.3337 6.66663L6.66699 13.3333M7.66858 17.1674C7.9417 17.1312 8.2176 17.2053 8.43518 17.3729L9.43787 18.1423C9.76933 18.397 10.2304 18.397 10.5609 18.1423L11.6016 17.3433C11.796 17.1942 12.0414 17.1285 12.2839 17.1609L13.5857 17.3322C13.9995 17.3868 14.3986 17.1562 14.5587 16.7701L15.0596 15.5591C15.1531 15.3322 15.3328 15.1526 15.5596 15.0591L16.7706 14.5582C17.1567 14.3989 17.3872 13.9989 17.3326 13.585L17.1678 12.3305C17.1317 12.0573 17.2057 11.7814 17.3733 11.5638L18.1427 10.5611C18.3973 10.2296 18.3973 9.76848 18.1427 9.43794L17.3437 8.39723C17.1946 8.20279 17.1289 7.95742 17.1613 7.71484L17.3326 6.41302C17.3872 5.99915 17.1567 5.60008 16.7706 5.4399L15.5596 4.93899C15.3328 4.84547 15.1531 4.66585 15.0596 4.439L14.5587 3.22793C14.3995 2.84182 13.9995 2.61128 13.5857 2.6659L12.2839 2.8372C12.0414 2.87053 11.796 2.80479 11.6025 2.65664L10.5619 1.85759C10.2304 1.60297 9.76933 1.60297 9.4388 1.85759L8.39815 2.65664C8.20372 2.80479 7.95837 2.87053 7.71579 2.83905L6.41405 2.66776C6.0002 2.61313 5.60116 2.84368 5.44098 3.22978L4.94102 4.44085C4.84659 4.66677 4.66697 4.8464 4.44107 4.94084L3.23006 5.44083C2.84398 5.60101 2.61344 6.00007 2.66807 6.41395L2.83935 7.71576C2.87083 7.95835 2.80509 8.20371 2.65696 8.39723L1.85795 9.43794C1.60334 9.76941 1.60334 10.2305 1.85795 10.5611L2.65696 11.6018C2.80602 11.7962 2.87175 12.0416 2.83935 12.2842L2.66807 13.586C2.61344 13.9998 2.84398 14.3989 3.23006 14.5591L4.44107 15.06C4.6679 15.1535 4.84751 15.3331 4.94102 15.56L5.44191 16.7711C5.60116 17.1572 6.00112 17.3877 6.41498 17.3331L7.66858 17.1674ZM7.91699 7.49996C7.91699 7.73008 7.73044 7.91663 7.50033 7.91663C7.27021 7.91663 7.08366 7.73008 7.08366 7.49996C7.08366 7.26984 7.27021 7.08329 7.50033 7.08329C7.73044 7.08329 7.91699 7.26984 7.91699 7.49996ZM12.917 12.5C12.917 12.7301 12.7304 12.9166 12.5003 12.9166C12.2702 12.9166 12.0837 12.7301 12.0837 12.5C12.0837 12.2698 12.2702 12.0833 12.5003 12.0833C12.7304 12.0833 12.917 12.2698 12.917 12.5Z"
                            stroke="#646A6C"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_2499_3466">
                            <rect width="20" height="20" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      {t("Social rewards")}
                    </Link>
                  </li>
                  <li className="nav-item" role="presentation">
                    <Link
                      className={`nav-link ${
                        state?.from === "gifts" && "active"
                      }`}
                      to={`${base_url}marketdashboard`}
                      state={{ from: "gifts" }}
                      id="riskfree-tab"
                      // data-bs-toggle="tab"
                      // data-bs-target="#riskfree"
                      // type="button"
                      // role="tab"
                      // aria-controls="riskfree"
                      // aria-selected="false"
                    >
                      <i className="fa-solid fa-shield-halved"></i> Gifts
                    </Link>
                  </li>
                  <li
                    className="nav-item"
                    role="presentation"
                    onClick={() => getrewoardhistory()}
                  >
                    <Link
                      className={`nav-link ${
                        state?.from === "rewards_history" && "active"
                      }`}
                      to={`${base_url}marketdashboard`}
                      state={{ from: "rewards_history" }}
                      id="rewardshistory-tab"
                      // data-bs-toggle="tab"
                      // data-bs-target="#rewardshistory"
                      // type="button"
                      // role="tab"
                      // aria-controls="riskfree"
                      // aria-selected="false"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width="18"
                        height="18"
                        fill="currentColor"
                      >
                        <path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12H4C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C9.25022 4 6.82447 5.38734 5.38451 7.50024L8 7.5V9.5H2V3.5H4L3.99989 5.99918C5.82434 3.57075 8.72873 2 12 2ZM13 7L12.9998 11.585L16.2426 14.8284L14.8284 16.2426L10.9998 12.413L11 7H13Z"></path>
                      </svg>{" "}
                      {t("Rewards History")}
                    </Link>
                  </li>
                </ul>
                <div className="tab-content" id="myTabContent">
                  <div
                       className={`tab-pane fade ${
                      state?.from === "market" && "show active" 
                    }`}
                    id="marketBonus"
                    role="tabpanel"
                    aria-labelledby="marketBonus-tab"
                  >
                    <div className="coupons_box cardBox mb-4">
                      <div className="row">
                        <div className="col-12">
                          <h4 className="card_title mb-4">
                            {t("Claim Bonus")}
                          </h4>
                        </div>
                        {couponlist?.length
                          ? couponlist.map((result, key) => {
                              return (
                                <div
                                  className="col-lg-4 col-md-6 col-sm-12"
                                  key={key}
                                >
                                  <div className="position-relative">
                                    <div className="coupon-card-mn">
                                      <div className="coupon-card">
                                        <p className="m1">
                                          {t("Min. Deposit")}:
                                        </p>
                                        <p className="m2 mb-2">
                                          ${result?.min_deposit}
                                        </p>
                                        <p className="m1">{t("Max. Bonus")}:</p>
                                        <p className="m2">
                                          ${result?.max_bonus}
                                        </p>
                                      </div>
                                      <div className="coup-tag">
                                        {" "}
                                        <img src={coupontag} alt="" />
                                        <span>{result?.discount}%</span>
                                      </div>
                                      <Link to="" onClick={(e)=>e.preventDefault()} className="claim-btn">
                                        {t("Claim Now")}
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                          : ""}
                      </div>
                    </div>
                  </div>
                  <div
                      className={`tab-pane fade ${
                      state?.from === "social_rewards" && "show active" 
                    }`}
                    id="SocialRewards"
                    role="tabpanel"
                    aria-labelledby="SocialRewards-tab"
                  >
                    <div className="cardBox">
                      <h4 className="card_title">{t("Social rewards")}</h4>
                      <p>
                        <small>
                          {t(
                            "Keep track and manage your social trading rewards that you receive when someone copies your trades."
                          )}
                        </small>
                      </p>
                      <h6 className="text-white mb-3">
                        {t(
                          "Every time a trader on the Platform copies your trade that is worth 5 USD or more, you automatically receive a reward in the form of Gem shards, which accumulate in your Rewards balance. The color of the Gem depends on the resulting amount of the trade copied by another user."
                        )}
                      </h6>
                      <h6 className="text-white mb-3">
                        {t(
                          "The statistics on the copied trades are updated and the corresponding rewards are sent to your balance daily. Collect whole Gems from the received shards and use them to purchase trading advantages in the Market."
                        )}
                      </h6>

                      <div className="row">
                        {rewardslist?.length
                          ? rewardslist.map((result, key) => {
                              return (
                                <div className="col-lg-4 col-md-4 mb-4">
                                  <div className="gem-shards-box h-100">
                                    <img
                                      src={result?.image}
                                      className="gem-shards-img"
                                      alt=""
                                    />
                                    <h5 className="gem-shards-title">
                                      {result?.name}{" "}
                                      <small>
                                        {t("Trade amount from")} $
                                        {result?.amount_from}{" "}
                                        {result?.amount_to
                                          ? `to $${result.amount_to}`
                                          : ""}
                                      </small>
                                    </h5>
                                    <div className="progress">
                                      <div
                                        className="progress-bar progress-bar-striped progress-bar-animated"
                                        role="progressbar"
                                        aria-valuenow={
                                          result?.user_reward
                                            ?.shards_collected || 0
                                        }
                                        aria-valuemin="0"
                                        aria-valuemax={
                                          result?.shards_required || 100
                                        }
                                        style={{
                                          width: `${
                                            result?.user_reward
                                              ?.shards_collected &&
                                            result?.shards_required
                                              ? (result.user_reward
                                                  .shards_collected /
                                                  result.shards_required) *
                                                100
                                              : 0
                                          }%`,
                                        }}
                                      ></div>
                                    </div>
                                    <h5 className="gem-shards-title">
                                      {result?.user_reward?.shards_collected
                                        ? result?.user_reward?.shards_collected
                                        : 0}{" "}
                                      / {result?.shards_required}
                                      <br />
                                      {t("Gems available")}:{" "}
                                      {result?.user_reward?.gems_available
                                        ? result?.user_reward?.gems_available
                                        : 0}
                                    </h5>
                                  </div>
                                </div>
                              );
                            })
                          : ""}
                      </div>

                      {/* <div className="my-3">
                        <h4 className="card_title mb-1">
                          The shard counter is updated once a day
                        </h4>
                        <p>
                          <small>UTC+2 00:00</small>
                        </p>
                      </div> */}

                      <div className="mb-2 pt-3">
                        <h4 className="card_title mb-1">
                          {t("Trending today")}
                        </h4>
                        <p>
                          <small>
                            {t(
                              "View and purchase the most popular trading benefits from the Market using your gem balance."
                            )}
                          </small>
                        </p>
                      </div>
                      <div className="row">
                        {rewardspilanlist?.length
                          ? rewardspilanlist.map((result, key) => {
                              return (
                                <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12 mb-4">
                                  <div className="gem-shards-box h-100">
                                    <h5 className="gem-shards-title">
                                      {result?.name}{" "}
                                      <small style={shardsstyle}>
                                        {result?.description}
                                      </small>
                                    </h5>
                                    <div className="w-100">
                                      <ul className="gem-shards-icons_x justify-content-center">
                                        {result?.shards_required?.["1"]
                                          ?.value !== "0" ? (
                                          <li>
                                            <img
                                              src={redgemshards}
                                              className="gem-shards-icon"
                                              alt="Red Gem Shards"
                                            />{" "}
                                            X
                                            {
                                              result?.shards_required?.["1"]
                                                .value
                                            }
                                          </li>
                                        ) : (
                                          ""
                                        )}
                                        {result?.shards_required?.["2"]
                                          ?.value !== "0" ? (
                                          <li>
                                            <img
                                              src={bluegemshards}
                                              className="gem-shards-icon"
                                              alt="Red Gem Shards"
                                            />{" "}
                                            X
                                            {
                                              result?.shards_required?.["2"]
                                                .value
                                            }
                                          </li>
                                        ) : (
                                          ""
                                        )}
                                        {/* <li>
                                          <img
                                            src={bluegemshards}
                                            className="gem-shards-icon"
                                            alt=""
                                          />{" "}
                                          X2
                                        </li> */}
                                        {result?.shards_required?.["3"]
                                          ?.value !== "0" ? (
                                          <li>
                                            <img
                                              src={greengemshards}
                                              className="gem-shards-icon"
                                              alt="Red Gem Shards"
                                            />{" "}
                                            X
                                            {
                                              result?.shards_required?.["3"]
                                                .value
                                            }
                                          </li>
                                        ) : (
                                          ""
                                        )}
                                        {/* <li>
                                          <img
                                            src={greengemshards}
                                            className="gem-shards-icon"
                                            alt=""
                                          />{" "}
                                          X1
                                        </li> */}
                                      </ul>
                                      <div className="btnsGroupPop mt-2">
                                        <button
                                          onClick={() => purchase(result?.id)}
                                          type="button"
                                          className="btn btnBorder btnGreen"
                                        >
                                          {t("Purchase")}
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                          : ""}
                      </div>
                    </div>
                  </div>
                  <div
                 className={`tab-pane fade ${
                      state?.from === "gifts" && "show active" 
                    }`}
                    id="riskfree"
                    role="tabpanel"
                    aria-labelledby="riskfree-tab"
                  >
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="cardBox">
                          <h4 className="card_title">Gifts </h4>
                          <div className="table-responsive">
                            <table
                              className="riskfreeTable table table-dark table-striped promo-table"
                              data-bs-theme="dark"
                            >
                              <thead>
                                <tr>
                                  <th>Gift</th>
                                  <th>Name</th>
                                  <th>status</th>
                                </tr>
                              </thead>
                              <tbody>
                                {paymentgiftlist?.length
                                  ? paymentgiftlist.map((result, key) => {
                                      return (
                                        <tr>
                                          <td>
                                            <img
                                              src={
                                                process.env
                                                  .REACT_APP_IMAGE_URL +
                                                result?.image
                                              }
                                              alt=""
                                            />
                                          </td>
                                          <td>
                                            {result?.name ? result?.name : "-"}
                                          </td>
                                          <td>
                                            {result?.can_redeem ? (
                                              <Link
                                                to={`${base_url}accounthistory`}
                                                state={{ from: "profile" }}
                                                className="text-decoration-none"
                                              >
                                                <button className="badge rounded-pill bg-secondary">
                                                  Redeem
                                                </button>
                                              </Link>
                                            ) : (
                                              <Link
                                                to={`${base_url}userdashboarddeposit`}
                                                state={{ from: "deposit" }}
                                                className="text-decoration-none"
                                              >
                                                <button className="badge rounded-pill bg-secondary">
                                                  Deposit
                                                </button>
                                              </Link>
                                            )}
                                          </td>
                                        </tr>
                                      );
                                    })
                                  : ""}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4"></div>
                      <div className="col-lg-4"></div>
                    </div>
                  </div>
                  <div
            className={`tab-pane fade ${
                      state?.from === "rewards_history" && "show active" 
                    }`}
                    id="rewardshistory"
                    role="tabpanel"
                    aria-labelledby="rewardshistory-tab"
                  >
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="cardBox">
                          <h4 className="card_title">
                            {t("Rewards History")}{" "}
                            {/* <span
                              className="tooltip01"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title="Use this promo code to cancel one of your loss trades. You can only cancel a non-hedged trade the amount of which does not exceed the maximum value of your promo code."
                            >
                              ?
                            </span> */}
                          </h4>
                          <div className="table-responsive">
                            <table
                              className="riskfreeTable table table-dark table-striped promo-table"
                              data-bs-theme="dark"
                            >
                              <thead>
                                <tr>
                                  <th>{t("Title")}</th>
                                  <th>{t("Reference trading id")}</th>
                                  <th>{t("Count")}</th>
                                </tr>
                              </thead>
                              <tbody>
                                {rewardhistorylist?.length ? (
                                  rewardhistorylist.map((result, key) => {
                                    return (
                                      <tr key={key}>
                                        <td>{result?.reward_name}</td>
                                        <td>
                                          {result?.trade_id
                                            ? result?.trade_id
                                            : "-"}
                                        </td>
                                        <td>
                                          <button className="badge rounded-pill bg-secondary">
                                            {result?.Count
                                              ? result?.Count
                                              : "0"}
                                          </button>
                                        </td>
                                      </tr>
                                    );
                                  })
                                ) : (
                                  <div
                                    style={{ marginLeft: "95%", width: "100%" }}
                                  >
                                    No Rewards History Data
                                  </div>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      {/* <div className="col-lg-4"></div> */}
                      {/* <div className="col-lg-4"></div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </React.Fragment>
  );
};

export default Marketdashboard;
